// extracted by mini-css-extract-plugin
module.exports = {"bg":"_dK","bg__imgWrapper":"_dL","bg__img":"_dM"};